import { render, staticRenderFns } from "./DetailEachDashboardLabNonStatus.vue?vue&type=template&id=1e63dfa2&scoped=true"
import script from "./DetailEachDashboardLabNonStatus.vue?vue&type=script&lang=js"
export * from "./DetailEachDashboardLabNonStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e63dfa2",
  null
  
)

export default component.exports